import React, { useEffect } from 'react';

import { useTabSettings } from 'utils/hooks/useTabSettings';
import { CHAT_CONTENT_TYPES } from 'components/evieApp/utils';

import Layout from 'components/evieOnboarding/Layout';
import AssistantAvatar from 'components/evieApp/AssistantAvatar';
import BottomNav from 'components/evieApp/BottomNav';
import AssistantContent from 'components/evieApp/AssistantContent';
import AudioView from 'components/evieApp/AudioView';
import ReadingView from 'components/evieApp/ReadingView';
import CapsuleView from 'components/evieApp/CapsuleView';
import DailyExercises from 'components/evieApp/DailyExercises';

import { EvieChatProvider, useEvieChatContext } from 'components/evieApp/EvieChatProvider';

import './evie-assistant.scss';

const AssistantWrapper = () => (
  <EvieChatProvider>
    <EvieAssistant />
  </EvieChatProvider>
);

const EvieAssistant = () => {
  useTabSettings('Evie', '/evie-favicon.ico');
  const { loading, isNative, assistantStatus, selectedContent, changeAssistantStatus, selectContent } =
    useEvieChatContext();

  useEffect(() => {
    if (isNative && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('ASSISTANT_MOUNTED');
    }
  }, []);

  const handleChangeAssistantStatus = () => {
    changeAssistantStatus(CHAT_CONTENT_TYPES.CHAT);
  };

  return (
    <Layout>
      {!isNative && assistantStatus === CHAT_CONTENT_TYPES.CHAT && <BottomNav />}
      {/* handle error here? */}
      {loading && <AssistantAvatar />}
      {!loading && assistantStatus === CHAT_CONTENT_TYPES.CHAT && <AssistantContent />}
      {!loading && assistantStatus === CHAT_CONTENT_TYPES.AUDIO && (
        <AudioView
          isAssistantView
          changeViewStatus={handleChangeAssistantStatus}
          selectContent={selectContent}
          selectedContent={selectedContent}
        />
      )}
      {!loading && assistantStatus === CHAT_CONTENT_TYPES.READING && (
        <ReadingView
          isAssistantView
          changeViewStatus={handleChangeAssistantStatus}
          selectContent={selectContent}
          selectedContent={selectedContent}
        />
      )}
      {!loading && assistantStatus === CHAT_CONTENT_TYPES.SHORT_VIDEO && (
        <CapsuleView
          isAssistantView
          changeViewStatus={handleChangeAssistantStatus}
          selectContent={selectContent}
          selectedContent={selectedContent}
        />
      )}
      {!loading && assistantStatus === CHAT_CONTENT_TYPES.EXERCISE && (
        <DailyExercises
          isAssistantView
          changeViewStatus={handleChangeAssistantStatus}
          selectContent={selectContent}
          selectedContent={selectedContent}
        />
      )}
    </Layout>
  );
};

export default AssistantWrapper;
